import React from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Chip
} from "@heroui/react";

interface CategoryChipsProps {
  title: string;
  categories: string | string[];
  className?: string;
  chipColor?: "default" | "primary" | "secondary" | "success" | "warning" | "danger";
  chipVariant?: "solid" | "bordered" | "light" | "flat" | "faded" | "shadow" | "dot";
}

/**
 * CategoryChips - A reusable component for displaying categories as chips in a card
 */
export default function CategoryChips({
  title,
  categories,
  className = "",
  chipColor = "primary",
  chipVariant = "flat"
}: CategoryChipsProps) {
  // Handle string input by splitting on commas
  const categoryArray = Array.isArray(categories) 
    ? categories 
    : categories.split(',').map(cat => cat.trim());
  
  return (
    <Card className={`shadow-sm border border-gray-200 ${className}`}>
      <CardHeader className="pb-0 px-6">
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
      </CardHeader>
      <CardBody className="p-6">
        <div className="flex flex-wrap gap-2">
          {categoryArray.map((category, index) => (
            <Chip
              key={index}
              variant={chipVariant}
              color={chipColor}
              size="sm"
            >
              {category}
            </Chip>
          ))}
        </div>
      </CardBody>
    </Card>
  );
}